export default __webpack_public_path__ + "static/FuturaBT-Bold-185a7aa7df07feea0fbf7cdb8533c974.ttf";